// @flow
export { default } from './EventHead';



// WEBPACK FOOTER //
// ./src/components/event/EventHead/index.js